module.exports = __webpack_public_path__ + "9ec2636.ttf";